<template>
  <div>
    <img src='../../assets/intefral.png' />
  </div>
</template>
<script>
export default {
  name: 'integralRule',
  data () {
    return {
      html: ''
    }
  },
  created () {},
  methods: {}
}
</script>
<style>
img{
  display: block;
  width: 100%;
  height: auto;
}
</style>
